import Vue from 'vue'
import {sync} from 'vuex-router-sync'
import App from '@/components/App'
import router from '@/router'
import store from '@/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueProgressBar from 'vue-progressbar'
import '@/assets/styles/main.scss'
import '@/assets/iconfont/iconfont.css'
import SymbolSvg from '@/components/SymbolSvg'
import '@/assets/iconfont/iconfont'
import { DataTables, DataTablesServer } from 'vue-data-tables'
import hover from '@/directives/hover'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ECharts from 'vue-echarts/components/ECharts'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

Vue.component('chart', ECharts)
Vue.component('SymbolSvg', SymbolSvg)

Vue.use(ElementUI)
Vue.use(DataTables)
Vue.use(DataTablesServer)
Vue.use(VueQuillEditor)

Vue.use(VueProgressBar, {
  color: '#13ce66'
})

sync(store, router)
Vue.directive('hover', hover)

// 全局无权限提醒
Vue.prototype.handlePermPrompt = function() {
  Vue.prototype.$message.warning('对不起，您暂未被开通权限')
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data() {
    return {
      init: false
    }
  }
})
